import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-search\"><g transform=\"translate(3 2)\" stroke=\"currentColor\" stroke-width=\"2\"><circle fill=\"transparent\" cx=\"9\" cy=\"9\" r=\"8\" /><path stroke-linecap=\"square\" d=\"M15.741 15.74l5.185 5.186\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol